// extracted by mini-css-extract-plugin
export default {"photosWrapper":"MediaGroup_photosWrapper__-SaYk"};